<template>
    <div class="wraper">
        <div>
            <firm-clues-info
                v-if="isFirm"
                :received-info="receivedInfo"
                :enable-clue="enableClue"
                :local-star-info="localStarInfo"
            />
            <lawyer-clues-info
                v-else
                :received-info="receivedInfo"
                :consume-type="consumeType"
                :local-star-info="localStarInfo"
                @changeConsumeType="changeConsumeType"
            ></lawyer-clues-info>
            <div class="content">
                <article>
                    <veui-tabs
                        ui="l"
                        :active="active"
                        @change="tabsChange"
                    >
                        <veui-tab label="认领公海" name="clueList"/>
                        <veui-tab label="已认领" name="already"/>
                        <veui-tab label="已被领满" name="isMax"/>
                    </veui-tabs>
                </article>
                <div
                    v-if="isVip
                        && userInfoNew.user_role !== 2
                        && vipInfo.vipStatusName !== 'beginnerVip'
                    "
                    class="sub-clue"
                    @click="handleSubShow"
                >
                    <img
                        class="sub-icon"
                        src="https://lvlin-base.cdn.bcebos.com/bend/sub-icon.png"
                    />
                    线索订阅配置（限时免费）
                </div>
                <!-- 律师且使用律所权益，且律所开通了本地之星权益时展示 -->
                <div
                    v-if="
                        +userInfoNew.user_role === 0 &&
                            +consumeType === 1 &&
                            localStarInfo &&
                            localStarInfo.length
                    "
                    class="tip-box"
                >
                    <div class="tip-icon"></div>
                    <div class="tip-text">
                        律所本地之星权益生效中，"{{
                            cityStr
                        }}"线索案源无限畅领，不消耗律所线索认领权益次数
                    </div>
                </div>
                <div class="already-fillter">
                    <veui-form
                        ref="form1"
                        class="form-box"
                        :data="formData"
                        @submit="searchClues"
                    >
                        <veui-field
                            name="areaSelected"
                            label="选择领域"
                            placeholder="请选择领域信息"
                        >
                            <veui-select
                                ref="domain"
                                v-model="formData.areaSelected"
                                overlay-class="law-clues-select"
                                class="choose-area"
                                clearable
                                searchable
                                multiple
                                :options="areaOptions"
                                :expanded="expandOption && expandOption.domain"
                                @toggle="(val) => toggle(val, 'domain')"
                            />
                        </veui-field>
                        <!-- 只能用v-show，不能用v-if select组件disabled的变换不会导致组件重新渲染更新,veui的问题 -->
                        <veui-field
                            v-show="active === 'clueList' && !notLimitUser"
                            label="选择地域"
                            field="registerRegion"
                            name="registerRegion"
                            help=""
                        >
                            <!-- tab为认领公海只可选择自己地域下的线索，其他地域设为不可选, isgrayall来进行区分 -->
                            <city-select
                                :is-gray-all="true"
                                :user-city="cityName"
                                @cityChange="cityChange"
                            ></city-select>
                        </veui-field>
                        <veui-field
                            v-if="!(active === 'clueList' && !notLimitUser)"
                            label="选择地域"
                            field="registerRegion"
                            name="registerRegion"
                        >
                            <!-- tab为认领公海只可选择自己地域下的线索，其他地域设为不可选, isgrayall来进行区分 -->
                            <city-select
                                :user-city="active === 'clueList' ? cityName : ''"
                                @cityChange="cityChange"
                            ></city-select>
                        </veui-field>
                        <veui-field
                            v-if="active === 'already'"
                            label="标记状态"
                            name="intentionStatus"
                        >
                            <veui-select
                                ref="state"
                                v-model="formData.intentionStatus"
                                clearable
                                class="choose-state"
                                placeholder="选择标记状态"
                                overlay-class="law-clues-select"
                                :options="intentionStatusOptions"
                                :expanded="expandOption && expandOption.state"
                                @toggle="(val) => toggle(val, 'state')"
                            />
                        </veui-field>
                        <veui-field
                            label="关键词"
                            field="keyword"
                            clearable
                            name="keyword"
                        >
                            <veui-search-box
                                v-model="formData.keyword"
                                ui="l"
                                placeholder="请输入法律关键词"
                            />
                        </veui-field>
                        <veui-button
                            ui="primary" type="submit"
                            class="search"
                        >
                            查询
                        </veui-button>
                    </veui-form>
                    <div
                        v-if="active === 'already'"
                        class="export-btn"
                        @click="exportOpen = true"
                    ><div class="export-icon"></div>导出数据</div>
                    <veui-dialog
                        title="导出数据"
                        :open.sync="exportOpen"
                        overlay-class="export-dialog"
                        @ok="handleExport"
                        @cancel="handleCancel"
                    >
                        <h4>请选择需要导出数据的时间范围</h4>
                        <veui-date-picker
                            v-model="exportDateRange"
                            range
                            clearable
                            :disabled-date="checkDateDisable"
                        ></veui-date-picker>
                    </veui-dialog>
                </div>
                <div
                    v-if="active === 'clueList' && showLawyerClueTip"
                    class="lawyer-clue-tip"
                >
                    系统已为您筛选出与您经营领域，地域相匹配的线索
                </div>
                <div v-if="active === 'clueList'" class="square">
                    <veui-table
                        v-if="clueList.length"
                        :data="clueList"
                        key-field="id"
                        :scroll="{x: 1104}"
                    >
                        <veui-table-column
                            field="name"
                            title="线索标题"
                            width="344"
                            align="left"
                        >
                            <template #default="{question, clue_collect_time}">
                                <overflow-tooltip
                                    overflow-class="title"
                                    overflow="y"
                                    :content="question"
                                    :date="clue_collect_time"
                                ></overflow-tooltip>
                            </template>
                        </veui-table-column>
                        <veui-table-column
                            field="clue_city"
                            width="160"
                            title="城市"
                            align="center"
                            tooltip
                        >
                        </veui-table-column>
                        <veui-table-column
                            field="clue_phone_num"
                            title="手机号"
                            class="phone"
                            width="160"
                        >
                            <template #default="{clue_phone_num}">
                                {{ clue_phone_num || "--" }}
                            </template>
                        </veui-table-column>
                        <veui-table-column
                            field="operation"
                            title="操作"
                            align="center"
                            :width="(vipInfo.vipStatusName === 'noVip' || vipInfo.vipStatusName === 'beginnerVip')
                                ? 192 : 120"
                            fixed="right"
                        >
                            <template
                                #default="{
                                    isBusiness,
                                    has_received,
                                    clue_id,
                                    leavings_bind_num,
                                    free_claim,
                                    clue_city,
                                    can_claim,
                                }"
                            >
                                <!-- eslint-disable -->
                                <veui-button
                                    v-if="+can_claim === 0"
                                    ref="update"
                                    ui="text"
                                    :disabled="+userInfoNew.user_role !== 0"
                                    class="update-btn"
                                    @click="updateBtnClick"
                                >升级会员，解锁线索</veui-button>
                                <div
                                    v-else
                                    class="modify-btn"
                                    :class="bindClass(has_received, free_claim)"
                                    @click="
                                        handleClaim({
                                            clue_id,
                                            has_received,
                                            leavings_bind_num,
                                            isBusiness,
                                            free_claim,
                                            clue_city,
                                        })
                                    "
                                >
                                    获取电话
                                </div>
                                <veui-tooltip
                                    target="update"
                                    position="left"
                                    overlay-class="update-tooltip"
                                    :hide-delay="10"
                                >您当前的会员类型不可领取此线索，升级会员{{ vipInfo.vipStatusName === 'noVip' && !isFirm ? '可认领线索' : '获取更多权益' }}</veui-tooltip>
                            </template>
                        </veui-table-column>
                    </veui-table>
                    <div v-else class="not-list">
                        <img
                            class="icon"
                            src="../../../assets/img/law/not-list.svg"
                            alt=""
                        />
                        暂无线索
                    </div>
                </div>
                <div v-else-if="active === 'isMax'" class="square">
                    <veui-table
                        v-if="fullClueList.length"
                        :data="fullClueList"
                        key-field="id"
                        :scroll="{x: 1104}"
                    >
                        <veui-table-column
                            field="name"
                            title="线索标题"
                            width="344"
                            align="left"
                        >
                            <template #default="{clue_question, clue_collect_time}">
                                <overflow-tooltip
                                    overflow-class="title"
                                    overflow="y"
                                    :content="clue_question"
                                    :date="clue_collect_time"
                                ></overflow-tooltip>
                            </template>
                        </veui-table-column>
                        <veui-table-column
                            field="clue_city"
                            width="160"
                            title="城市"
                            align="center"
                            tooltip
                        >
                        </veui-table-column>
                        <veui-table-column
                            field="clue_phone_num"
                            title="手机号"
                            class="phone"
                            width="160"
                        >
                            <template #default="{clue_phone_num}">
                                {{ clue_phone_num || "--" }}
                            </template>
                        </veui-table-column>
                        <veui-table-column
                            field="operation"
                            title="操作"
                            align="center"
                            width="120"
                            fixed="right"
                            disabled
                        >
                            <veui-button
                                ui="text"
                                disabled
                            >
                                已被领满
                            </veui-button>
                        </veui-table-column>
                    </veui-table>
                    <div v-else class="not-list">
                        <img
                            class="icon"
                            src="../../../assets/img/law/not-list.svg"
                            alt=""
                        />
                        暂无线索
                    </div>
                </div>
                <div v-else class="alreadyClaim">
                    <veui-table
                        v-if="recordList.length"
                        :data="recordList"
                        key-field="id"
                        :scroll="{x: 1104}"
                    >
                        <veui-table-column
                            v-if="isFirm"
                            field="dispatch_time"
                            title="认领时间"
                            width="100"
                            align="center"
                        />
                        <veui-table-column
                            field="name"
                            title="线索标题"
                            width="550"
                            align="left"
                        >
                            <template #default="{question, clue_collect_time}">
                                <overflow-tooltip
                                    overflow-class="title"
                                    overflow="y"
                                    :content="question"
                                    :date="clue_collect_time"
                                ></overflow-tooltip>
                            </template>
                        </veui-table-column>
                        <veui-table-column
                            field="clue_city"
                            width="160"
                            title="城市"
                            align="center"
                            tooltip
                        >
                        </veui-table-column>
                        <veui-table-column
                            field="intention_status"
                            title="标记状态"
                            width="140"
                            align="center"
                        >
                            <template #default="{intention_status, index}">
                                <div class="intention">
                                    <veui-dropdown
                                        :label="
                                            intentionStatusMap[
                                                +intention_status
                                            ]?.text || '未标记'
                                        "
                                        ui="text"
                                        :options="
                                            intentionStatusOptions.slice(1)
                                        "
                                        @click="
                                            (val) =>
                                                handleChangeIntention(
                                                    val,
                                                    index
                                                )
                                        "
                                    />
                                </div>
                            </template>
                        </veui-table-column>
                        <veui-table-column
                            field="clue_phone_num"
                            title="手机号"
                            class="phone"
                            width="160"
                        >
                            <template #default="{clue_phone_num}">
                                {{ clue_phone_num || "--" }}
                            </template>
                        </veui-table-column>
                        <veui-table-column
                            v-if="!isFirm"
                            field="dispatch_time"
                            title="认领时间"
                            width="160"
                        >
                            <template #default="{dispatch_time}">
                                {{ dispatch_time || '' }}
                            </template>
                        </veui-table-column>
                        <veui-table-column
                            v-if="!isFirm"
                            field="owner_type"
                            title="线索归属"
                            desc="线索归属"
                            width="100"
                            align="center"
                        >
                            <template #default="{owner_type}">
                                <p>
                                    {{ ownerTypeMap[owner_type] }}
                                </p>
                            </template>
                        </veui-table-column>
                        <veui-table-column
                            v-if="isFirm"
                            field="owner_name"
                            title="认领成员"
                            width="150"
                            align="center"
                        />
                        <veui-table-column
                            field="operation"
                            title="操作"
                            align="center"
                            width="188"
                            fixed="right"
                        >
                            <template
                                #default="{
                                    index,
                                    virtual_phonenum,
                                    expire_time,
                                    owner_name,
                                }"
                            >
                                <div class="opt-box">
                                    <div
                                        v-if="isFirm"
                                        class="btn"
                                        @click="openUserDialog(index)"
                                    >
                                        换人跟进
                                    </div>
                                    <div
                                        v-if="
                                            !isFirm ||
                                                (isFirm &&
                                                    owner_name === '律所管理员')
                                        "
                                        class="btn ml"
                                        @click="clickPhone(index)"
                                    >
                                        拨打电话
                                        <effect-time
                                            v-if="virtual_phonenum"
                                            :end-time="expire_time"
                                            :virtual-number="virtual_phonenum"
                                            :is-default="false"
                                        />
                                    </div>
                                </div>
                            </template>
                        </veui-table-column>
                    </veui-table>
                    <div v-else class="not-list">
                        <img
                            class="icon"
                            src="../../../assets/img/law/not-list.svg"
                            alt=""
                        />
                        暂无线索
                    </div>
                </div>
                <veui-pagination
                    v-if="page.total"
                    class="pagination"
                    :page="page.pn"
                    :page-size="page.rn"
                    :total="page.total"
                    @redirect="pageChange"
                />
                <!-- 电话弹框 -->
                <veui-dialog
                    ui="narrow"
                    title="您可以直接通过手机联系用户"
                    :open.sync="isShowPhone"
                    overlay-class="order-management-dialog"
                >
                    <p>用户手机号码如下：{{ phoneInfo.clue_phone_num }}</p>
                    <template #foot>
                        <veui-button
                            ui="m primary"
                            @click="isShowPhone = false"
                        >
                            我知道了
                        </veui-button>
                    </template>
                </veui-dialog>
                <!-- 认领失败弹框 -->
                <veui-dialog
                    ui="narrow"
                    :open.sync="errorClaim"
                    overlay-class="order-management-dialog"
                >
                    <template #title>
                        <veui-icon
                            class="times-circle"
                            name="times-circle"
                        />认领失败
                    </template>
                    <p class="margin-l">{{ errorMsg }}</p>
                    <template #foot>
                        <veui-button
                            ui="m primary"
                            class="margin-l"
                            @click="handleclose('errorClaim')"
                        >
                            我知道了
                        </veui-button>
                    </template>
                </veui-dialog>
                <veui-dialog
                    ui="narrow"
                    :open.sync="confirmRepeatClaim"
                    overlay-class="order-management-dialog"
                >
                    <template #title> 确认认领 </template>
                    <p>该线索手机号您已认领过,是否还要继续认领?</p>
                    <template #foot>
                        <veui-button ui="m primary" @click="confirmClaim(1)">
                            确认认领
                        </veui-button>
                        <veui-button
                            ui="m"
                            @click="handleclose('confirmRepeatClaim')"
                        >
                            取消
                        </veui-button>
                    </template>
                </veui-dialog>
                <!-- 确认认领弹框 -->
                <veui-dialog
                    ui="narrow"
                    :open.sync="showConfirmClaim"
                    overlay-class="defirm-receive-dialog"
                >
                    <template #title> 确认认领 </template>
                    <p
                        v-if="currentClue.isLocalStarClue"
                        class="receive-content"
                    >
                        本条线索享受本地之星（{{
                            currentClue.clue_city
                        }}线索无限认领）权益，认领将不消耗您任何线索权益额度，请放心确认。
                    </p>
                    <template v-else>
                        <p>
                            确认后将消耗一次【{{
                                userView === '2' ? "律所" : "个人"
                            }}线索认领权益】次数，确定要认领该线索吗?
                        </p>
                        <div class="cluim-number">
                            您当前认领次数还剩:<span>{{
                                userView === '2'
                                    ? receivedInfo.business_month_remain
                                    : receivedInfo.person_month_remain
                            }}</span>条
                        </div>
                    </template>
                    <template #foot>
                        <veui-button
                            class="cancel"
                            ui="strong"
                            @click="handleclose('showConfirmClaim')"
                        >
                            取消
                        </veui-button>
                        <veui-button
                            class="confirm"
                            ui="primary"
                            :disabled="!formData.term"
                            @click="confirmClaim(0)"
                        >
                            确认
                        </veui-button>
                        <div class="claim-agreement">
                            <veui-checkbox v-model="formData.term">
                                我已阅读并接受
                            </veui-checkbox>
                            <span
                                class="agreement" @click.stop="openBuyRule"
                            >《线索认领协议》</span>
                        </div>
                    </template>
                </veui-dialog>
                <veui-dialog
                    overlay-class="unband-confirm"
                    title="更换跟进成员"
                    :open.sync="isConfirmShow"
                >
                    <p class="confirm-text">
                        当前认领成员： {{ currentRecord.owner_name }}
                    </p>
                    <div class="lawyer-box">
                        <p class="confirm-text">更换为：</p>
                        <veui-select
                            v-model="newLawyerName"
                            placeholder="选择律师"
                            class="lawyer-search"
                        >
                            <veui-option
                                v-for="(item, index) in lawyerList"
                                :key="index"
                                :value="item.name"
                                :label="item.name"
                            />
                        </veui-select>
                    </div>
                    <template #foot>
                        <div class="btn-box">
                            <div
                                class="btn-item"
                                @click="handleclose('isConfirmShow')"
                            >
                                取消
                            </div>
                            <div
                                class="btn-item confirm"
                                @click="confirmChange"
                            >
                                完成
                            </div>
                        </div>
                    </template>
                </veui-dialog>
            </div>
        </div>
        <veui-dialog
            ui="narrow"
            title=""
            :open.sync="showNoMemberModal"
            overlay-class="order-management-dialog"
        >
            <p>
                您还不是{{ noMemberModalText[0] }},无法使用认领功能,点击“{{ noMemberModalText[1] }}”,即刻享受线索认领和内容认领权益
            </p>
            <template #foot>
                <veui-button ui="m primary" @click="jumplawservice">
                    {{ noMemberModalText[2] }}
                </veui-button>
            </template>
        </veui-dialog>
        <sub-clue
            v-if="clueSubscibeInfo && isVip"
            ref="subclue"
            :clue-subscibe-info="clueSubscibeInfo"
            :area-options="areaOptions"
        ></sub-clue>
    </div>
</template>

<script>
import {
    Tabs,
    Tab,
    Form,
    Field,
    Button,
    Select,
    Pagination,
    Table,
    Column,
    SearchBox,
    Dialog,
    Icon,
    Checkbox,
    Dropdown,
    Option,
    DatePicker,
    Tooltip
} from 'veui';
import EffectTime from './effectTime.vue';
import SubClue from './subscript.vue';
import LawyerCluesInfo from './lawyerCluesInfo.vue';
import FirmCluesInfo from './firmCluesInfo.vue';
import {cloneDeep} from 'lodash';
import {mapState, mapMutations} from 'vuex';
import {MARK_MAP, MARK_OPTIONS} from '../../../common/index';
import overflowTooltip from '../../../components/overflowTooltip.vue';
import citySelectNew from '../../../components/citySelectNew';
import {downloadFile} from '@/utils/download';
import {expertise_area_level1} from '@/utils/domains';
import dayjs from 'dayjs';
/**
 * @file index.vue
 * @author sunhemeng
 * @desc 线索公海
 */
const url = {
    // 消息列表
    clueSelectItem: 'law:/themis/law/commodity/clueselectiterm',
    vipBuyIndex: '/bp/api/vip/claim_clue_index',
    vipBuyClueList: '/bp/api/clue/claim_list',
    clueQuerySelect: 'law:/themis/law/commodity/clue_queryselect',
    buyPreorder: '/bp/api/clue/claim',
    buyRecord: '/bp/api/clue/claimed_list',
    cityNext: 'law:/themis/law/city/cityAll',
    changeClueOwner: '/bp/api/clue/change_clue_owner',
    getBusinessMember: '/bp/api/business/getlawyerlist',
    getFilterList: '/bp/api/clue/dispatch_filter'
};
export default {
    name: 'lawclues',
    components: {
        'veui-tabs': Tabs,
        'veui-tab': Tab,
        'veui-form': Form,
        'veui-field': Field,
        'veui-select': Select,
        'veui-button': Button,
        'veui-pagination': Pagination,
        'veui-table': Table,
        'veui-table-column': Column,
        'veui-search-box': SearchBox,
        'effect-time': EffectTime,
        'veui-dialog': Dialog,
        'veui-icon': Icon,
        'lawyer-clues-info': LawyerCluesInfo,
        'veui-checkbox': Checkbox,
        'veui-dropdown': Dropdown,
        'veui-option': Option,
        'sub-clue': SubClue,
        'firm-clues-info': FirmCluesInfo,
        'overflow-tooltip': overflowTooltip,
        'city-select': citySelectNew,
        'veui-date-picker': DatePicker,
        'veui-tooltip': Tooltip
    },
    data() {
        return {
            currentClue: '', // 当前即将认领的线索
            active: 'clueList', // 当前tab
            receivedInfo: { // 顶部信息汇总
                all_month_received: 0, // 律师已认领全部
                all_month_remain: 0, // 剩余本月总认领
                all_received: 0, // 总认领
                clue_quota: 0, // 总上限
                person_month_remain: 0, // 个人会员剩余总认领
                business_month_remain: 0, // 机构分配线上剩余
                monthBusinessReceived: 0, // 月累计已消耗机构认领
                business_received: 0, // 总数累计已消耗机构认领
                business_clue_quota: 0 // 机构分配线索上限
            },
            formData: { // 查询表单数据
                areaSelected: [],
                registerRegion: [],
                intentionStatus: '',
                clueTag: '',
                keyword: '',
                term: false
            },
            areaOptions: [], // 领域下拉框数据
            regionOption: [], // 地域下拉框数据
            intentionStatusOptions: MARK_OPTIONS, // 标记状态下拉框数据
            intentionStatusMap: MARK_MAP, // 标记状态下拉框数据
            ownerTypeMap: { // 线索归属
                1: '机构',
                2: '个人',
                3: '律所'
            },
            clueList: [], // 线索列表
            page: { // 线索列表分页信息
                pn: 1,
                rn: 10,
                total: 0
            },
            recordList: [], // 认领记录列表
            errorMsg: '',
            errorClaim: false,
            showConfirmClaim: false, // 本地之星确认认领弹框
            confirmRepeatClaim: false, // 重复认领弹框
            showNoMemberModal: false, // 无会员弹框
            noMemberModalText: ['律临VIP会员', '成为会员', '成为会员'],
            showLawyerClueTip: false, // 提示律师线索红字
            clueSubscibeInfo: null, // 线索订阅信息
            isVip: false, // 是否是VIP会员
            isShowPhone: false, // 线索电话弹窗
            phoneInfo: {}, // 线索电话弹窗信息
            isConfirmShow: false, // 换人跟进弹框
            newLawyerName: '律所管理员',
            lawyerList: [], // 换人跟进的律师列表
            isChangeUser: false, // 换绑提交的锁
            isConfirmLock: false, // 换绑获取列表的锁
            consumeType: '0', //  1： 律所额度  0：会员额度
            currentRecord: {}, // 换人跟进的当前线索
            enableClue: 0,
            localStarInfo: [], // 本地之星城市信息
            isSubmit: false, // 提交锁
            fullClueList: [], // 已认领满的线索列表
            expandOption: {'domain': false, 'city': false, 'state': false}, // 下拉框是否展开
            exportOpen: false, // 数据导出弹框,
            exportDateRange: null, // 数据导出时间范围
            cityName: '', // 用户填写认证的当前城市名称
            showDomain: [] // 认领公海的律师可展示领域 & 默认领域
        };
    },
    created() {
        if (Object.keys(this.userInfoNew).length === 0) {
            setTimeout(() => {
                this.getData();
            }, 500);
        }
        else {
            this.getData();
        }
    },
    computed: {
        ...mapState({
            statistics: state => state.Statistics.statistics,
            userInfoNew: state => state.lawStore.userInfoNew,
            vipInfo: state => state.lawStore.vipInfo,
            passInfo: state => state.lawStore.userInfoNew?.pass_info || {},
            authenticationStatus: state => state.lawStore.authenticationStatus,
            // 律师、律所都在使用此页面
            businessId: state => state.lawStore.userInfoNew?.lawyer_info?.business_id
                || state.lawStore.userInfoNew?.law_business_info?.id || 0
        }),
        // 本地之星城市字符串
        cityStr() {
            let str = '';
            this.localStarInfo.forEach((item, index) => {
                str += item.city;
                if (index < this.localStarInfo.length - 1) {
                    str += '、';
                }
            });
            return str;
        },
        userNoRemain() {
            return (
                (+this.consumeType === 0
                    && this.receivedInfo.person_month_remain <= 0)
                || (+this.consumeType === 1
                    && this.receivedInfo.business_month_remain <= 0)
            );
        },
        userView() {
            const {user_role} = this.userInfoNew;
            const {consumeType} = this;
            return (+user_role === 2 || consumeType === '1') ? '2' : '1';
        },
        firmVip() {
            const {business_privilege_info} = this.vipInfo || {};
            return !!business_privilege_info.is_vip;
        },
        notLimitUser() {
            const {is_old_vip} = this.vipInfo;
            const {user_role} = this.userInfoNew;
            return (+user_role === 0 && this.consumeType === '1') || (+user_role === 2 && this.firmVip) || is_old_vip;
        },
        isFirm() { // 律所
            return +this.userInfoNew?.user_role === 2;
        }
    },
    watch: {
        vipInfo: {
            handler() {
                this.getData();
            },
            deep: true
        },
        active: {
            handler(val) {
                if (val !== 'clueList') {
                    this.showLawyerClueTip = false;
                    // 除认领公海tab下的领域选项不做置灰操作
                    this.areaOptions.forEach(item => {
                        item.disabled = false;
                    });
                    if (val === 'already') {
                        // tab 变为已认领，监听选择状态下拉框
                        this.$nextTick(() => {
                            this.stateObserver = this.handleIntersection(this.$refs.state.$el, 'state');
                        });
                    }
                }
                else {
                    if (this.notLimitUser) {
                        return;
                    }
                    const domain = this.showDomain || [];
                    this.areaOptions.forEach(item => {
                        item.disabled = !domain.includes(item.value);
                    });
                }
            }
        }
    },
    mounted() {
        this.$log && this.$log.send({
            type: 'show',
            value: 'law-clue-show'
        });
        this.$nextTick(() => {
            // 初始tab为认领公海， 监听选择领域与选择地域
            this.domainObserver = this.handleIntersection(this.$refs.domain.$el, 'domain');
        });
    },
    destroyed() {
        this.stateObserver && this.stateObserver.disconnect();
        this.domainObserver && this.domainObserver.disconnect();
        this.cityObserver && this.cityObserver.disconnect();
    },
    methods: {
        ...mapMutations({
            emitEvent: 'EventBus/emitEvent'
        }),
        getDataBefor() {
            if (+this.userInfoNew.user_role === 2) {
                this.formData.registerRegion = this.userInfoNew?.law_business_info?.city_name
                    ? [this.userInfoNew?.law_business_info?.city_name]
                    : [];
                this.getDataFn();
            }
            else if (+this.userInfoNew.user_role === 0) {
                const {register_domains_v1 = ''} = this.userInfoNew?.lawyer_info || {};
                this.showDomain = register_domains_v1 && register_domains_v1.split('$') || [];
                this.formData.areaSelected = this.showDomain;
                this.$http
                    .get(url.clueSelectItem)
                    .then(res => {
                        const respData = this.$normalizeResponseData(res);
                        const {city = ''} = respData || {};
                        if (city) {
                            this.formData.registerRegion
                                = (respData.city && [respData.city]) || [];
                            this.showLawyerClueTip = true;
                        }
                        this.getDataFn();
                    })
                    .catch(() => {
                        this.getDataFn();
                    });
            }
        },
        // 处理导出数据
        handleExport() {
            if (this.exportDateRange && this.exportDateRange[0] && this.exportDateRange[1]) {
                this.exportDateRange_start = (
                    +this.exportDateRange[0] / 1000
                ).toFixed(0);
                this.exportDateRange_end = +((+this.exportDateRange[1] / 1000).toFixed(0)) + 86399;
            };
            const text = dayjs(new Date()).format('YYYYMMDD_HHmm');
            this.exportDateRange = null;
            if (this.exportDateRange_start && this.exportDateRange_end) {
                downloadFile(
                    `/bp/api/clue/claimed_list_export?begin_ts=${this.exportDateRange_start}`
                        + `&end_ts=${this.exportDateRange_end}&view=${this.userView}`,
                    `已认领导出-${text}.csv`
                );
                // 初始化开始结束时间
                this.exportDateRange_start = null;
                this.exportDateRange_end = null;
                // 关闭弹窗
                this.exportOpen = false;
                this.$toast.success('数据导出成功');
            }
            else {
                this.exportOpen = true;
                this.$toast.error('请选择正确的时间范围');
            }
        },
        // 判断时间是否可选
        checkDateDisable(date, oldDate) {
            const startDate = oldDate && dayjs(oldDate).subtract(90, 'day');
            const endDate = oldDate && dayjs(oldDate).add(90, 'day') || dayjs(new Date());
            // 只可选择一个季度范围之内的数据进行导出，并且关注时间不能超过当前时间
            if (date && dayjs(date) > startDate && dayjs(date) < endDate && dayjs(date) < dayjs(new Date())) {
                return false;
            }
            return true;
        },
        // 关闭弹窗
        handleCancel() {
            this.exportOpen = false;
            this.exportDateRange = null;
        },
        // 城市改变
        cityChange(val) {
            this.formData.registerRegion = val;
        },
        // 下拉框的选择
        toggle(val, key) {
            this.expandOption[key] = val;
        },
        // 元素是否在视口的监听, 用于下拉框的关闭操作, key用于判断是第几个下拉框
        handleIntersection(element, key) {
            const observer = new IntersectionObserver(entries => {
                entries.forEach(entry => {
                    // 如果元素不在视口内，关闭下拉框的展开
                    if (!entry.isIntersecting) {
                        this.expandOption[key] = false;
                    }
                });
            });
            // 开始观察元素
            observer.observe(element);
            return observer;
        },
        // 认领禁用样式处理
        bindClass(hasReceived, free_claim) {
            // 已经认领过
            if (+hasReceived === 1) {
                return 'gray';
            }
            // 律所：律所未被授予认领额度、开通了本地之星但是不是本地之星城市且无额度、未开通本地之星且无额度
            if (+this.userInfoNew.user_role === 2) {
                if (
                    (this.localStarInfo.length
                        && !free_claim
                        && !this.receivedInfo.business_month_remain)
                    || (!this.localStarInfo.length
                        && !this.receivedInfo.business_month_remain)
                    || !this.enableClue
                ) {
                    return 'disabled';
                }
            }
            // 律师：优先消耗律所额度,或者优先消耗律师额度但是律师额度用完了
            if (+this.consumeType === 1 || !this.receivedInfo.person_month_remain) {
                if (
                    !this.localStarInfo.length
                    && !this.receivedInfo.all_month_remain
                ) {
                    return 'disabled';
                }
                if (
                    this.localStarInfo.length
                    && !free_claim
                    && !this.receivedInfo.business_month_remain
                ) {
                    return 'disabled';
                }
            }
        },
        getData() {
            this.$http.get(url.vipBuyIndex, {
                params: {
                    user_type: this.userInfoNew.user_role
                }
            }).then(resp => {
                if (+resp.code === 0 && resp.data) {
                    const respData = resp.data;
                    const user_info = respData.user_info || {};
                    user_info.received = user_info.received || {};
                    user_info.received.can_use_business = user_info.can_use_business || false;
                    this.receivedInfo = user_info.received;
                    this.enableClue = user_info.isVip ? 1 : 0;
                    this.localStarInfo = user_info.localstar_info || [];
                    if (respData.clueSubscibeInfo) {
                        respData.clueSubscibeInfo.is_subscibe
                            = !!respData.clueSubscibeInfo.is_subscibe;
                    }
                    this.clueSubscibeInfo = respData.clueSubscibeInfo || {};
                    this.isVip
                        = respData.user_info && respData.user_info.isVip;
                }
                this.cityName = resp?.data?.user_info?.cityName || '';
                this.pageLoading = false;
                this.getDataBefor();
                this.getDomain();
            }).catch(err => {
                this.$normalizeResponseError(err);
                this.getDataBefor();
                this.getDomain();
            });
        },
        handleclose(type) {
            this[type] = false;
            this.formData.term = false;
        },
        handleClaim(clue) {
            const {vipStatus, privilege_info, vipStatusName, validityStart} = this.vipInfo;
            // 个人信息认证未通过-引导去认证
            if (this.authenticationStatus < 7 && !validityStart) {
                this.emitEvent({
                    name: 'global_free_vip_event',
                    payload: {
                        dialogType: 'authentice'
                    }
                });
                return;
            }

            // 当前后台线索与策略派发的线索有重复
            if (clue.has_received) {
                this.$Message.error('您已认领该线索，请选择其他线索');
                return;
            }

            // 启航会员：限制其线索认领功能
            if (+vipStatus === 1 && vipStatusName === 'beginnerVip') {
                this.showNoMemberModal = true;
                this.noMemberModalText = ['尊享会员', '成为尊享会员', '成为尊享会员'];
                return;
            }
            // 非会员
            if (!this.isVip) {
                // 体验会员过期用户
                if (privilege_info && +privilege_info.vip_code_type === 6) {
                    this.emitEvent({name: 'global_free_vip_event', payload: {
                        dialogType: 'expire-no-avatar',
                        expireKeywords: '线索认领'
                    }});
                    return;
                }
                this.showNoMemberModal = true;
                return;
            }
            // 律所管理员未被授权可领取线索
            if (+this.userInfoNew.user_role === 2 && !this.enableClue) {
                this.errorMsg = '您当前未被授权使用律所权益领取线索';
                this.errorClaim = true;
                return;
            }
            // 已经认领过
            if (+clue.hasReceived === 1) {
                this.errorMsg = '您已认领过该线索，请勿重复认领';
                this.errorClaim = true;
                return;
            }
            this.currentClue = cloneDeep(clue);
            // 开通了本地之星且是本地的城市且优先消耗律所权益
            if (clue.free_claim && +this.consumeType === 1) {
                this.currentClue.isLocalStarClue = 1;
                this.showConfirmClaim = true;
                return;
            }
            // 律所账号，律所额度无剩余且非本地之星
            if (
                +this.userInfoNew.user_role === 2
                && !this.receivedInfo.business_month_remain
                && !clue.free_claim
            ) {
                this.errorMsg = '当月律所线索认领次数已用完，暂时无法认领线索';
                this.errorClaim = true;
                return;
            }
            // 律所下的律师认领线索，使用律所额度但是没有剩余量时，弹窗提示切换到个人权益
            if (!this.isFirm && +this.consumeType === 1 && !this.receivedInfo.business_month_remain) {
                this.errorMsg = '律所线索额度已全部被消耗，请切换为个人版权益';
                this.errorClaim = true;
                return;
            }
            if (+this.userInfoNew.user_role === 0) {
                // 个人律师情况
                const lawyerNoRemain
                    = +this.consumeType === 0
                        && !this.receivedInfo.all_month_remain;
                const firmNoRemain
                    = +this.consumeType === 1
                        && !this.receivedInfo.business_month_remain;
                // 开通了本地之星且非本地城市且无额度 或 未开通本地之星且律师律所都无额度
                if (
                    (this.localStarInfo.length
                        && !clue.free_claim
                        && (lawyerNoRemain || firmNoRemain))
                    || (!this.localStarInfo.length
                        && !this.receivedInfo.all_month_remain)
                ) {
                    // 优先使用律师额度，律所开通了本地之星，但是律师和律所额度都用完了且选中的不是本地城市，切换成律所额度，但是提示认领失败
                    if (
                        lawyerNoRemain
                        && this.localStarInfo.length
                        && !clue.free_claim
                    ) {
                        this.consumeType = '1';
                    }
                    // 优先使用律所额度，律所未开通本地之星，且律所无额度了，切换成律师额度，但是提示认领失败
                    if (firmNoRemain && !this.localStarInfo.length) {
                        this.consumeType = '0';
                    }
                    const text
                        = +this.consumeType === 1 ? '律所线索' : '个人权益线索';
                    this.$Message.error(`当月${text}认领次数已用完，暂时无法认领线索`);
                    return;
                }
                // 律所权益消耗为空改为个人权益
                if (
                    +this.consumeType === 1
                    && !this.receivedInfo.business_month_remain
                    && !this.localStarInfo.length
                ) {
                    this.consumeType = '0';
                }
                // 个人权益消耗为空改为律所权益
                if (
                    +this.consumeType === 0
                    && !this.receivedInfo.person_month_remain
                    && (this.receivedInfo.business_month_remain
                        || this.localStarInfo.length)
                ) {
                    this.consumeType = '1';
                    this.currentClue.isLocalStarClue = clue.free_claim;
                }
            }
            this.showConfirmClaim = true;
        },
        confirmClaim(confirm = 0) {
            // 为勾选协议或者防连点
            if (!this.formData.term || this.isSubmit) {
                return;
            }
            this.isSubmit = true;
            this.$http
                .post(url.buyPreorder, {
                    ...{
                        user_type: this.userInfoNew.user_role,
                        clue_id: this.currentClue.clue_id,
                        confirm_buy: confirm,
                        useBusinessClue: this.isFirm ? 1 : +this.consumeType
                    },
                    timeout: 300000
                })
                .then(res => {
                    if (+res.code === 120004) {
                        this.confirmRepeatClaim = true;
                        this.showConfirmClaim = false;
                    }
                    else if (+res.code ===  120002) {
                        this.errorMsg = '当前线索已经售出';
                        this.confirmRepeatClaim = false;
                        this.showConfirmClaim = false;
                        this.errorClaim = true;
                    }
                    else if ([120001, 120003].includes(+res.code)) {
                        this.errorMsg = res.msg;
                        this.confirmRepeatClaim = false;
                        this.showConfirmClaim = false;
                        this.errorClaim = true;
                    }
                    else if (+res.code === 0) {
                        this.confirmRepeatClaim = false;
                        this.showConfirmClaim = false;
                        this.errorClaim = false;
                        this.$Message.success(
                            '认领成功，可前往已认领列表查看!'
                        );
                        this.getClueList();
                        this.$http
                            .get(url.vipBuyIndex, {
                                params: {
                                    user_type: this.userInfoNew.user_role
                                }
                            })
                            .then(resp => {
                                const respData = resp?.data || {};
                                this.receivedInfo = respData.user_info?.received || {};
                            })
                            .catch(err => this.$normalizeResponseError(err));
                    }
                    else {
                        this.$Message.error((res && res.msg) || '认领失败');
                        this.showConfirmClaim = false;
                        this.confirmRepeatClaim = false;
                    }
                })
                .finally(() => {
                    this.isSubmit = false;
                });
        },
        searchClues(data, e) {
            this.page.pn = 1;
            this.showLawyerClueTip = false;
            this.getDataFn();
        },
        getDomain() {
            if (!this.notLimitUser && !this.isFirm) {
                const domain = this.showDomain || [];
                this.areaOptions = expertise_area_level1.map(item => ({
                    label: item.text,
                    // 默认为认领公海的tab，并且在认领公海tab下的领域，若非律师自己对应的领域(showDomain), 则领域选项置灰
                    // 该策略仅用于新会员
                    disabled: !domain.includes(item.value),
                    ...item
                }));
            }
            else {
                this.areaOptions = expertise_area_level1.map(item => ({
                    label: item.text,
                    // 默认为认领公海的tab，并且在认领公海tab下的领域，若非律师自己对应的领域(showDomain), 则领域选项置灰
                    // 该策略仅用于新会员
                    ...item
                }));
            }
        },
        getClueList() {
            let {
                areaSelected = [],
                keyword = '',
                registerRegion = [],
                clueTag = ''
            } = this.formData;
            registerRegion = registerRegion && registerRegion.join(',');
            areaSelected = areaSelected && areaSelected.join(',');
            const {pn = 1, rn = 10} = this.page;
            this.$http
                .get(url.vipBuyClueList, {
                    params: {
                        vn: 'law',
                        clientType: 'h5',
                        pn,
                        rn,
                        view: this.userView,
                        keyword,
                        expertise_area_level1: areaSelected || '',
                        clue_city: registerRegion || '',
                        clue_tag: clueTag || '',
                        collect_time_start: 2
                    }
                })
                .then(res => {
                    const respData = this.$normalizeResponseData(res);
                    this.page = {
                        pn: pn || respData.pn,
                        rn: 10,
                        total: respData.total
                    };
                    if (respData && respData.list) {
                        respData.list = respData.list.map(item => {
                            item.question = item.question.replaceAll(' ', '，');
                            return item;
                        });
                        this.clueList = respData.list || [];
                    }
                    else {
                        this.clueList = [];
                        this.page = {
                            pn: 1,
                            rn: 10,
                            total: 0
                        };
                    }
                })
                .catch(err => {
                    this.$normalizeResponseError(err);
                    this.clueList = [];
                    this.page = {
                        pn: 1,
                        rn: 10,
                        total: 0
                    };
                });
        },
        getRecordClueList() {
            this.recordList = [];
            let {
                areaSelected = [],
                keyword = '',
                intentionStatus = '',
                registerRegion = []
            } = this.formData;
            registerRegion = registerRegion.join(',');
            areaSelected = areaSelected.join(',');
            const {pn = 1, rn = 10} = this.page;
            this.$http
                .get(url.buyRecord, {
                    params: {
                        vn: 'law',
                        clientType: 'h5',
                        pn,
                        rn,
                        keyword,
                        view: this.userView,
                        expertise_area_level1: areaSelected || '',
                        clue_city: registerRegion,
                        intention_status: intentionStatus || ''
                    }
                })
                .then(res => {
                    const respData = this.$normalizeResponseData(res);
                    this.page.total = respData.total || 0;
                    this.recordList = respData.list || [];
                });
        },
        pageChange(page) {
            this.page.pn = page;
            this.getDataFn();
        },
        tabsChange(e) {
            const name = e.name;
            if (name !== this.active) {
                this.page.pn = 1;
                this.page.total = 0;
                this.active = name;
                this.$refs.form1.reset();
                this.formData.areaSelected = [];
                this.formData.registerRegion = [];
                this.getDataFn();
            }
        },
        openBuyRule() {
            window.open(
                'https://law-smartapp.cdn.bcebos.com/pdf/user-rule.pdf'
            );
        },
        jumplawservice() {
            if (this.userInfoNew && this.userInfoNew.user_role === 2) {
                this.$router.push({name: 'firmIndex'});
            }
            else {
                this.$router.push({name: 'lawservice'});
            }
        },
        getDataFn() {
            if (this.active === 'clueList') {
                this.getClueList();
            }
            else if (this.active === 'isMax') {
                this.getFullClueList();
            }
            else {
                this.getRecordClueList();
            }
        },
        handleSubShow() {
            this.$refs.subclue.showSubClueModal = true;
            this.$log
                && this.$log.send({
                    type: 'clk',
                    value: 'sub-show',
                    ext: {
                        name:
                            this.passInfo.uname || ''
                    }
                });
        },
        // 换人更近弹框
        openUserDialog(index) {
            if (this.lawyerList.length > 0) {
                this.newLawyerName = '律所管理员';
                this.currentRecord = this.recordList[index];
                this.isConfirmShow = true;
                return;
            }
            if (this.isConfirmLock) {
                return;
            }
            this.isConfirmLock = true;
            this.currentRecord = this.recordList[index];
            const params = {
                businessId: this.businessId,
                pn: this.pn,
                show: ''
            };
            this.$http
                .get(url.getBusinessMember, {
                    params
                })
                .then(res => {
                    const data = this.$normalizeResponseData(res);
                    if (data) {
                        let list = data.list || [];
                        list.unshift({
                            name: '律所管理员'
                        });
                        this.lawyerList = list;
                        this.count = data.count || 0;
                        this.isConfirmShow = true;
                    }
                    else {
                        this.lawyerList = [];
                        this.count = 0;
                    }
                    this.isConfirmLock = false;
                })
                .catch(err => {
                    this.$normalizeResponseError(err);
                    this.isConfirmLock = false;
                });
        },
        // 确定换人
        confirmChange() {
            if (this.isChangeUser) {
                return;
            }
            this.isChangeUser = true;
            const params = {
                mode: 'claim',
                ori_name: this.currentRecord.owner_name,
                clue_id: this.currentRecord.clue_id,
                target_name: this.newLawyerName
            };
            this.$http
                .post(url.changeClueOwner, {
                    ...params
                })
                .then(res => {
                    this.isChangeUser = false;
                    if (res.code !== '0') {
                        this.$normalizeResponseError(res);
                        return;
                    }
                    this.$Message.success('已成功换绑成员跟进');
                    this.getDataFn();
                })
                .catch(err => {
                    this.$normalizeResponseError(err);
                    this.isChangeUser = false;
                });
            this.handleclose('isConfirmShow');
        },
        // 取消换人弹框
        hideConfirm() {
            this.isConfirmShow = false;
        },
        clickPhone(index) {
            let phoneInfo = this.recordList[index] || {};
            this.phoneInfo = phoneInfo;
            if (phoneInfo.clue_phone_num) {
                this.isShowPhone = true;
            }
        },

        /**
         * 更改标记
         * @param {String} value 标记值
         * @param {Number} index
         */
        handleChangeIntention(value, index) {
            const {clue_id} = this.recordList[index] || {};
            if (clue_id) {
                this.$http
                    .post('/bp/api/clue/mark_clue_status', {
                        clue_id,
                        view: this.userView,
                        intention_status: value
                    })
                    .then(res => {
                        if (+res?.code === 0) {
                            this.$set(
                                this.recordList[index],
                                'intention_status',
                                value
                            );
                        }
                        else {
                            this.$normalizeResponseError(res);
                        }
                    });
            }
        },

        changeConsumeType(value) {
            this.consumeType = value;
            if (this.active === 'clueList') {
                this.getDomain();
                this.getClueList();
            }
            if (this.active === 'already') {
                this.getRecordClueList();
            }
        },
        // 获取已认领满线索列表
        getFullClueList() {
            this.fullClueList = [];
            let {
                areaSelected = [], // 领域
                keyword = '', // 关键词
                registerRegion = [] // 地域
            } = this.formData;
            registerRegion = registerRegion.join(',');
            areaSelected = areaSelected.join(',');
            const {pn = 1, rn = 10} = this.page;
            this.$http
                .get('/bp/api/clue/full_claim_list', {
                    params: {
                        vn: 'law',
                        clientType: 'h5',
                        pn,
                        rn,
                        keyword,
                        expertise_area_level1: areaSelected || '',
                        clue_city: registerRegion
                    }
                })
                .then(res => {
                    const respData = this.$normalizeResponseData(res);
                    this.page.total = respData.total || 0;
                    this.fullClueList = respData.list || [];
                });
        },

        /**
         * 按钮点击
         */

        updateBtnClick() {
            let {userInfoNew, authenticationStatus, vipInfo = {}} = this;
            let {user_role} = userInfoNew || {};
            let {vipStatus, privilege_info} = vipInfo;
            // 只针对律师
            if (+user_role !== 0) {
                return;
            }
            // 个人信息认证通过，且未领取过体验会员
            if (authenticationStatus === 7 && !vipInfo.validityStart) {
                this.emitEvent({
                    name: 'global_free_vip_event',
                    payload: {
                        dialogType: 'receive'
                    }
                });
                return;
            }
            // 个人信息认证未通过-引导去认证, 且未领取过体验会员
            if (authenticationStatus < 7 && !vipInfo.validityStart) {
                this.emitEvent({
                    name: 'global_free_vip_event',
                    payload: {
                        dialogType: 'authentice'
                    }
                });
                return;
            }
            // 非会员
            if (!+vipStatus) {
                // 体验会员过期用户
                if (privilege_info && +privilege_info.vip_code_type === 6) {
                    this.emitEvent({
                        name: 'global_free_vip_event',
                        payload: {
                            dialogType: 'expire-no-avatar'
                        }
                    });
                    return;
                }
            }
        }
    }
};
</script>
<style lang="stylus" scoped>
@import "../../../assets/css/law-table.styl";

.export-dialog {
    /deep/.veui-dialog-content {
        width: 350px !important;
    }

    .veui-date-picker {
        margin-top: 10px;
    }
}

.update-tooltip {
    /deep/.veui-tooltip {
        background-color: rgba(0, 0, 0, .7);
        color: white;
    }

    /deep/ .veui-tooltip-arrow {
        color: rgba(0, 0, 0, .7);
    }
}

.banner {
    height: 96px;
    margin: 24px 0;
    background: url("https://law-smartapp.cdn.bcebos.com/pdf/law-banner-clue.png") no-repeat;
    background-size: 100% 100%;
}

.content {
    background: #fff;
    padding: 6px 30px 30px 30px;
    box-sizing: border-box;
    position: relative;
    margin-top: 24px;
    box-shadow: 0 6px 14px 0 rgba(227, 233, 237, .35);
    border-radius: 8px;

    /deep/ .veui-input[ui~="l"] {
        height: 40px;
    }

    /deep/ .ivu-input,
    .veui-search-box,
    .veui-select {
        width: 220px;
        min-height: 40px;
    }

    /deep/ .veui-select-trigger {
        padding-right: 2px;
    }

    /deep/ .veui-input-after {
        display: flex;
        align-items: center;
        min-height: 40px;
        margin: 0;
    }

    /deep/ .veui-field-label {
        width: 68px;
        text-align: right;
        margin-right: 0;
        margin-top: 4px;
        padding-right: 12px;
        box-sizing: border-box;
    }

    /deep/ .veui-field {
        margin-bottom: 16px;
    }

    /deep/ .veui-tag {
        height: 28px;
        font-size: 14px;
        margin-top: 5px;
    }

    /deep/ .veui-field:not(:last-child) {
        margin-right: 48px;
    }

    /deep/ .veui-table [role="cell"] {
        padding: 18px 16px;
    }

    /deep/ .veui-field-content {
        display: block;
    }

    /deep/ .veui-tabs-item + .veui-tabs-item {
        margin-left: 18px;
    }

    /deep/ .veui-tabs-menu {
        height: 48px;
    }

    .already-fillter {
        position: relative;

        .export-btn {
            position: absolute;
            right: 16px;
            bottom: 15px;
            height: 40px;
            display: flex;
            align-items: center;
            color: #05f;
            font-size: 16px;
            font-family: PingFangSC-Medium;
            cursor: pointer;

            .export-icon {
                margin-right: 4px;
                width: 15px;
                height: 16.25px;
                background: url(https://lvlin-base.cdn.bcebos.com/fe-saas/page/offline-qa/export.png) no-repeat center center / 100% 100%;
            }
        }
    }

    .square {
        .modify-btn {
            font-size: 16px;
            color: #05f;
            cursor: pointer;
        }

        .update-btn {
            font-size: 16px;
            color: #a54300;
            font-family: PingFangSC-Medium;
        }

        .disabled {
            opacity: .5;
        }

        .gray {
            color: #ccc;
        }
    }

    .title {
        font-size: 16px;
        color: #333;
        line-height: 26px;
        font-weight: 500;
        white-space: break-spaces;
        word-break: break-all;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        line-clamp: 2;
        -webkit-box-orient: vertical;
        max-width: 608px;
    }

    .alreadyClaim {
        .opt-box {
            display: flex;
            justify-content: space-between;

            .btn {
                font-size: 16px;
                color: #3e4cff;
                cursor: pointer;
            }

            .ml {
                margin-left: 14px;
            }
        }

        .disabled {
            color: #999;
        }
    }
}

.form-box {
    margin-top: 24px;
    display: flex;
    width: 100%;
    flex-wrap: wrap;

    /deep/ .choose-area {
        .veui-input {
            min-height: 40px;
        }
    }

    /deep/ .choose-state {
        .veui-input {
            height: 40px;
        }
    }

    .search {
        width: 80px;
        height: 40px;
        margin-left: -24px;
    }
}

.ivu-cascader {
    /deep/ .ivu-input {
        width: 180px;
        height: 30px;
        border: 1px solid #d3d9e6;
    }
}

.lawyer-clue-tip {
    font-size: 16px;
    color: red;
    line-height: 22px;
    padding-bottom: 20px;
}

.pagination {
    width: 100%;
    margin-top: 24px;
    justify-content: flex-end;
    padding-right: 36px;
    box-sizing: border-box;

    /deep/ .veui-pagination-info {
        display: none;
    }
}

a {
    color: #0052cc;
}

a::hover {
    color: #06f;
}

a::active {
    color: #0045ad;
}

.times-circle {
    margin-right: 12px;
}

.defirm-receive-dialog {
    .receive-content {
        font-family: PingFangSC-Regular;
        font-size: 14px;
        color: #000;
        letter-spacing: 0;
        line-height: 22px;
        font-weight: 400;
    }

    /deep/.veui-dialog-content {
        width: 420px !important;
    }

    /deep/.veui-dialog-content-head {
        font-family: PingFangSC-Medium !important;
        font-size: 16px !important;
        color: #000 !important;
        padding: 30px 24px 30px 30px !important;
    }

    /deep/.veui-dialog-content-body {
        padding: 0 30px !important;
    }

    /deep/.veui-dialog-content-foot {
        padding-top: 36px !important;
        text-align: center;

        .veui-button {
            height: 40px;
            width: 86px;
            border-radius: 5px;
        }

        .confirm {
            margin-left: 24px !important;
        }
    }

    .cluim-number {
        min-width: 214px;
        height: 48px;
        background: #f9f9f9;
        border-radius: 4px;
        font-family: PingFangSC-Regular;
        font-size: 14px;
        color: #282c33;
        line-height: 14px;
        padding: 16px 0 0 12px;
        box-sizing: border-box;
        margin-top: 7px;

        span {
            font-family: PingFangSC-Medium;
            font-size: 24px;
            color: #282c33;
            line-height: 24px;
            font-weight: 500;
            margin: 0 9px;
        }
    }

    .claim-agreement {
        margin-top: 12px;

        .agreement {
            font-family: PingFangSC-Regular;
            font-size: 14px;
            color: #0052cc;
            cursor: pointer;
        }

        /deep/ .veui-checkbox {
            vertical-align: text-top;
        }
    }
}

.margin-l {
    margin-left: 36px;
}

.not-call {
    color: #ff321b;
}

.not-list {
    display: flex;
    justify-content: center;
    align-items: center;
    color: #a8b0bf;
    flex-direction: column;
    margin: 38px 0;
}

.sub-clue {
    width: 230px;
    height: 24px;
    position: absolute;
    top: 27px;
    right: 0;
    font-family: PingFangSC-Semibold;
    font-size: 16px;
    color: #05f;
    line-height: 1;
    cursor: pointer;

    .sub-icon {
        width: 18px;
        height: 18px;
        vertical-align: sub;
    }
}

.tip-box {
    display: flex;
    background: #e5f1ff;
    padding: 15px 24px;
    align-items: center;
    margin-top: 33px;

    .tip-icon {
        width: 20px;
        height: 20px;
        background: url("https://lvlin-base.cdn.bcebos.com/bend/icon-warning.png") no-repeat center center / 100% 100%;
        margin-right: 5px;
        flex-shrink: 0;
        transform: rotate(180deg);
    }

    .tip-text {
        font-size: 14px;
        color: #333;
    }
}

.unband-confirm {
    /deep/ .veui-dialog-content {
        width: 420px;
    }

    /deep/ .veui-input {
        height: 32px;
    }

    .confirm-text {
        height: 24px;
        line-height: 24px;
        color: #000;
    }

    .lawyer-box {
        display: flex;
        align-items: center;
        margin: 18px 0 12px;

        .lawyer-search {
            width: 298px;
        }
    }

    .confirm-tip {
        color: #999;
        line-height: 22px;
    }

    .btn-box {
        display: flex;
        align-items: center;
        justify-content: center;

        .btn-item {
            border: 1px solid rgba(56, 85, 213, 1);
            border-radius: 5px;
            padding: 10px 29px;
            font-size: 14px;
            color: #3855d5;
            cursor: pointer;
        }

        .confirm {
            background: #3855d5;
            color: #fff;
            margin-left: 24px;
        }
    }
}
</style>
<style lang="stylus">
.law-clues-select .veui-select-options[ui~="m"] {
    max-height: initial;
}
</style>
